<template>
    <div class="settlement_box">
        <el-dialog :close-on-click-modal="false" :modal-append-to-body="false" custom-class="delCarMusic" title="用户认证"
            :visible.sync="UserAuthentication" width="540px" :before-close="handleClose">
            <p class="pay_before" v-if="$store.state.status==0">购买前，您需要先完成身份验证（认证后在“我的订单”进行支付）</p>
            <p class="pay_before" v-if="$store.state.status==1">身份认证审核中，审核后方可购买</p>
            <p class="pay_before" v-if="$store.state.status==3">身份认证审核失败，前往修改</p>
            <span class="pay_info">
                实名认证信息将作为后续采购音乐版权的授权主体，以及开具发票的发票抬头
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleExit">取 消</el-button>
                <el-button type="primary" @click="certification(0)" v-if="$store.state.status==0">去认证</el-button>
                <el-button type="primary" @click="certification(1)" v-if="$store.state.status==1">确认</el-button>
                <el-button type="primary" @click="certification(3)" v-if="$store.state.status==3">前往修改</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            UserAuthentication: false,
        }
    },
    methods: {
        handleClose() {
            this.UserAuthentication = false
            // 在订单页面点击取消就回到首页
            if (this.flag == 'payOrder') {
                this.$router.push('home')
            }
        },
        certification(val) {
            switch (val) {
                case 0:
                    this.$router.push({
                        path: '/authentication'
                    })
                    break;
                case 1:
                    this.UserAuthentication = false
                    break;
                case 3:
                    this.$router.push({
                        path: '/authentication',
                        query: {
                            flag: 'revise'
                        }
                    })
                    break;
            }

        },
        handleExit() {
            this.UserAuthentication = false
            // 在订单页面点击取消就回到首页
            if (this.flag == 'payOrder') {
                this.$router.push('home')
            }
        }
    },
    props: {
        flag: {
            type: String
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__title {
    font-weight: 600;
}


.settlement_box {
    .pay_before {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 16px;
    }

    .pay_info {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 14px;
    }
}
</style>